<template>
  <piepkaart :minLoadDataZoom="1">
    <template v-slot="{ bounds, minLoadDataZoom }">
      <piepkaart-wfs-layer
        :bounds="bounds"
        :minLoadDataZoom="minLoadDataZoom"
        wfs-url="https://atlas.brabant.nl/arcgis/services/pgr_m01_milieu/MapServer/WFSServer"
        type-name="pgr_m01_milieu:Voormalige_stortplaatsen"
        output-format="GEOJSON"
        srs-name="EPSG:4326"
        :use-proxy="true"
        :use-bbox="false"
        :onEachFeature="onEachFeature"
        :styleOptions="styleOptions"
        :minRefetchDistance="10"
      ></piepkaart-wfs-layer>
    </template>
  </piepkaart>
</template>
<script>
import Piepkaart from "@/components/Piepkaart.vue";
import PiepkaartWfsLayer from "@/components/PiepkaartWfsLayer.vue";
import L from "leaflet";
export default {
  name: "Noord-Brabant",
  components: {
    Piepkaart,
    PiepkaartWfsLayer,
  },
  data() {
    return {
      maxBounds: L.latLngBounds([
        [51.23313285157451, 4.205627642185379],
        [51.82192803413396, 6.016423773414977],
      ]),
    };
  },
  methods: {
    styleOptions() {
      return {
        weight: 3,
        color: "#3B82F6",
        opacity: 1,
        fillColor: "#3B82F6",
        fillOpacity: 0.8,
      };
    },
    onEachFeature(feature, layer) {
      if (feature.properties) {
        layer.bindPopup(
          `
            <div>
              <div style="font-weight: 600">${feature.properties.NAAM}</div>
              <div>Plaats: ${feature.properties.PLAATS}</div>
            </div>
            `,
          {
            closeButton: false,
            autoPan: false,
          }
        );
      }
    },
  },
  created() {
    this.$store.commit("center", this.maxBounds.getCenter());
    this.$store.commit("zoom", 10);
  },
};
</script>
